import { IoClose } from "react-icons/io5";

import { useAccount } from "wagmi";

import { ConnectWalletButton } from "features/connect-wallet";
import { useBuildCommandMutation } from "shared/api/use-build-command-mutation";
import WasabiLogo from "shared/assets/wasabi-logo.svg?react";
import { Button } from "shared/ui/button";
import { Dialog } from "shared/ui/dialog";

type Props = {
  refLink: string;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
};

export const InviteDialog = ({ refLink, isOpen, onOpenChange }: Props) => {
  const { isConnected } = useAccount();

  const buildCommandMutation = useBuildCommandMutation();

  const handleBuildCommand = () => {
    buildCommandMutation.mutate(
      { name: "rewards-program", args: { invite: refLink } },
      {
        onSuccess: () => {},
      }
    );
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Content className="md:max-w-sm">
        <Dialog.Body className="flex flex-col items-center gap-0 px-6 py-3.5">
          <Dialog.Close asChild className="ml-auto">
            <Button variant="nobel/10" className="size-9.5 p-0">
              <IoClose className="size-6" />
            </Button>
          </Dialog.Close>
          <div className="bg-spearmint size-14 rounded-[18px] p-2.5">
            <WasabiLogo className="size-full text-black" />
          </div>
          <Dialog.Title className="mt-5 p-0 text-center text-[28px] leading-[105%]">
            You are invited through the referral program
          </Dialog.Title>
          <Dialog.Description className="text-nobel/70 mt-4 flex text-center leading-[150%]">
            Confirm invitation to points program by signing this messafe. It’s
            free
          </Dialog.Description>

          {isConnected && (
            <Button
              variant="ultramarineBlue"
              className="mt-10 w-full"
              onClick={handleBuildCommand}
            >
              Build Command
            </Button>
          )}

          {!isConnected && <ConnectWalletButton className="mt-10 w-full" />}
          <Dialog.Close asChild>
            <Button className="mt-3 w-full">Close</Button>
          </Dialog.Close>
        </Dialog.Body>
      </Dialog.Content>
    </Dialog>
  );
};
